import React, { FC } from 'react';

// components
import BasicButton from '../../components/buttons/basicButton';
import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

interface FormulaEditViewActionsProps {
    onSave: () => void;
    onCancel: () => void;
    isLoading?: boolean;
    disabled?: boolean;
}
const FormulaEditViewActions: FC<
    React.PropsWithChildren<FormulaEditViewActionsProps>
> = ({ onSave, onCancel, isLoading, disabled }) => {
    return (
        <Container>
            <BasicButton
                isPrimary={false}
                name={'Cancel'}
                action={onCancel}
                disabled={isLoading}
            />
            <BasicButton
                name={'Save'}
                action={onSave}
                isLoading={isLoading}
                disabled={disabled}
            />
        </Container>
    );
};
const Container = styled.div({
    display: 'flex',
    gap: aampeTheme.spacing(1),
});
export default FormulaEditViewActions;
